module.exports = __webpack_public_path__ + "img/recruit1.8117020c.png";